import noimage from '@/assets/images/no_image.svg';

function formatePdfImageData(patentImg) {
    if (patentImg && patentImg.resolution) {
        if (!patentImg.pp_bbox) {
            return {
                type: 'offical',
                src: noimage,
            };
        }
        let boxArr = patentImg.resolution.split('x');
        let { x1, y1, x2, y2 } = patentImg.pp_bbox;
        let model = {
            id: patentImg.page_index,
            path: patentImg.url || patentImg.storage_path,
            oriWidth: boxArr[0],
            oriHeight: boxArr[1],
            image_type: patentImg.image_type || '',
            box: [x1, y1, x2, y2],
        };
        return {
            model,
            type: 'patsnap',
        };
    } if (patentImg && patentImg.url) {
        return {
            type: 'offical',
            src: patentImg.url,
        };
    }
    return {
        type: 'offical',
        src: noimage,
    };

}

function formatePdfImageDataV2(patentImg) {
    if (patentImg && patentImg.resolution) {
        let boxArr = patentImg.resolution.split('x');
        let { x1, y1, x2, y2, category } = patentImg.pp_bbox;
        let model = {
            category,
            type: 'patsnap',
            id: patentImg.id || 'undefined',
            fig_title_code: patentImg.fig_title_code,
            path: patentImg.url || patentImg.storage_path,
            oriWidth: boxArr[0],
            oriHeight: boxArr[1],
            image_type: patentImg.image_type || '',
            box: Object.preventExtensions([x1, y1, x2, y2]),
            image_from: patentImg.image_from,
            // 以下属性给Image_For_Lab使用
            edit_count: patentImg.edit_count,
        };
        model.image4Figures = model.path;
        return model;
    }
    if (patentImg && (patentImg.url || patentImg.storage_path || patentImg.fulltext_image_url)) {
        let url = patentImg.url || patentImg.storage_path || patentImg.fulltext_image_url;
        return {
            category: patentImg.category,
            id: patentImg.id || 'undefined',
            fig_title_code: patentImg.fig_title_code,
            type: 'offical',
            path: url,
            src: url,
            originSrc: url,
            image4Figures: url,
            image_from: patentImg.image_from,
            image_type: patentImg.image_type || '',
            box: Object.preventExtensions([0, 0, 1, 1]),
            imageId: patentImg.image_id,
            // 以下属性给Image_For_Lab使用
            replace_abstract_image: patentImg.replace_abstract_image,
            edit_count: patentImg.edit_count,
            image_source: patentImg.image_source,
        };
    }
    return {
        type: 'offical',
        src: noimage,
    };
}

export { formatePdfImageData, formatePdfImageDataV2 };
